module.exports = __webpack_public_path__ + "assets/img/Blackpurl-Landing-Page-w960.24c69e34.webp";